import type { CMSAccordionContainerDTO } from "~/features/cms/types/dto";
import { renderCMSComponent } from "~/features/cms/componentFactory";
import { AccordionGroup, AccordionGroupTitle } from "~/common/mui/Accordion/AccordionGroup";

interface Props extends Omit<CMSAccordionContainerDTO, "type"> {
  className?: string;
}

export const CMSAccordionContainer = (props: Props) => {
  return (
    <AccordionGroup>
      <AccordionGroupTitle>{props.title}</AccordionGroupTitle>
      {props.accordionItems.map((accordion, index) => {
        return renderCMSComponent(accordion, undefined, index);
      })}
    </AccordionGroup>
  );
};
